"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
exports.useNotificationsContext = exports.useTransactionsContext = void 0;
__exportStar(require("./DAppProvider"), exports);
__exportStar(require("./blockNumber"), exports);
__exportStar(require("./chainState"), exports);
__exportStar(require("./config"), exports);
var context_1 = require("./transactions/context");
__createBinding(exports, context_1, "useTransactionsContext");
var context_2 = require("./notifications/context");
__createBinding(exports, context_2, "useNotificationsContext");
__exportStar(require("./transactions/model"), exports);
__exportStar(require("./notifications/model"), exports);
//# sourceMappingURL=index.js.map